<template>
  <v-expansion-panels focusable>
    <v-expansion-panel>
      <v-expansion-panel-header>Executar {{ metodologiaAneel.nome }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row class="mt-4" align="center">
          <v-col cols="3">
            <v-text-field
              v-model="parametros_execucao.dif_dec_fec_aceita_aneel"
              label="dif_dec_fec_aceita_aneel"
              type="number"
              step="0.1"
              min="0"
            />
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="3">
            <v-text-field
              v-model="parametros_execucao.perc_validacao_dec_fec_limite_inferior"
              label="perc_validacao_dec_fec_limite_inferior"
              type="number"
              step="1"
            />
          </v-col>
          <v-col cols="1">%</v-col>
          <v-col cols="3">
            <v-text-field
              v-model="parametros_execucao.perc_validacao_dec_fec_limite_superior"
              label="perc_validacao_dec_fec_limite_superior"
              type="number"
              step="1"
            />
          </v-col>
          <v-col cols="5">%</v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="3">
            <v-text-field
              v-model="parametros_execucao.perc_validacao_nuc_limite_inferior"
              label="perc_validacao_nuc_limite_inferior"
              type="number"
              step="1"
            />
          </v-col>
          <v-col cols="1">%</v-col>
          <v-col cols="3">
            <v-text-field
              v-model="parametros_execucao.perc_validacao_nuc_limite_superior"
              label="perc_validacao_nuc_limite_superior"
              type="number"
              step="1"
            />
          </v-col>
          <v-col cols="1">%</v-col>
          <v-col cols="4">
            <v-btn
              title="Executar a metodologia com os parâmetros informados"
              outlined
              :loading="loading"
              :disabled="!podeExecutarMetodologia"
              @click="executarMetodologia()"
            >
              Executar
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import ValidacoesIndqualService from '@/services/ValidacoesIndqualService';

  export default {
    name: 'FormExecucaoMetodologia2',
    props: {
      metodologiaAneel: {
        type: Object,
        required: true
      },
      bdgdVersao: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      loading: false,
      parametros_execucao: {
        dif_dec_fec_aceita_aneel: 0.2,
        perc_validacao_dec_fec_limite_inferior: -5,
        perc_validacao_dec_fec_limite_superior: 10,
        perc_validacao_nuc_limite_inferior: -10,
        perc_validacao_nuc_limite_superior: 15
      }
    }),
    computed: {
      podeExecutarMetodologia() {
        const {
          dif_dec_fec_aceita_aneel,
          perc_validacao_dec_fec_limite_inferior,
          perc_validacao_dec_fec_limite_superior,
          perc_validacao_nuc_limite_inferior,
          perc_validacao_nuc_limite_superior
        } = this.parametros_execucao;
        return (
          dif_dec_fec_aceita_aneel !== '' &&
          perc_validacao_dec_fec_limite_inferior !== '' &&
          perc_validacao_dec_fec_limite_superior !== '' &&
          perc_validacao_dec_fec_limite_inferior < perc_validacao_dec_fec_limite_superior &&
          perc_validacao_nuc_limite_inferior !== '' &&
          perc_validacao_nuc_limite_superior !== '' &&
          perc_validacao_nuc_limite_inferior < perc_validacao_nuc_limite_superior
        );
      }
    },
    methods: {
      executarMetodologia() {
        this.loading = true;
        ValidacoesIndqualService.executarMetodologia(this.metodologiaAneel.id, this.bdgdVersao.id, this.parametros_execucao)
          .then(() => {
            this.$toast.success(`${this.metodologiaAneel.nome} executada com sucesso.`, '', { position: 'topRight' });
            this.$emit('metodologiaExecutada');
          })
          .catch(() => {
            this.$toast.error(`Erro ao tentar executar a ${this.metodologiaAneel.nome}.`, '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
